import { render, staticRenderFns } from "./PhoneVerification.vue?vue&type=template&id=17ab4635"
import script from "./PhoneVerification.vue?vue&type=script&lang=js"
export * from "./PhoneVerification.vue?vue&type=script&lang=js"
import style0 from "./PhoneVerification.vue?vue&type=style&index=0&id=17ab4635&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports